import { useParams, Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';
import Breadcrumb from '@/components/base/Breadcrumb';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeSlug, setActiveSlug] = useState(slug || 'cat-culture');

  useEffect(() => {
    if (slug) setActiveSlug(slug);
  }, [slug]);

  const currentCategory = categories.find((c) => c.slug === activeSlug);
  const categoryArticles = articles.filter((a) => a.category === activeSlug);

  const breadcrumbItems = [
    { label: '首页', href: '/' },
    { label: currentCategory?.name || '分类' },
  ];

  if (!currentCategory) {
    return (
      <div className="min-h-screen flex items-center justify-center pt-16">
        <p className="text-foreground-600">分类不存在</p>
      </div>
    );
  }

  return (
    <main className="min-h-screen pt-16">
      <div className="bg-background-100 border-b border-background-200/60">
        <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
          <div className="mb-4">
            <Breadcrumb items={breadcrumbItems} />
          </div>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-full bg-primary-50 flex items-center justify-center">
              <i className={`${currentCategory.icon} text-primary-500 text-lg w-5 h-5 flex items-center justify-center`} />
            </div>
            <h1 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950 whitespace-nowrap">
              {currentCategory.name}
            </h1>
          </div>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl leading-relaxed">
            {currentCategory.description}
          </p>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 md:px-6 py-6">
        <div className="flex flex-wrap items-center gap-2 pb-6 border-b border-background-200/60 mb-8">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap ${
                activeSlug === cat.slug
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              {cat.name}
            </Link>
          ))}
        </div>

        {categoryArticles.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {categoryArticles.map((article) => (
              <ArticleCard key={article.slug} article={article} variant="default" />
            ))}
          </div>
        ) : (
          <div className="text-center py-20">
            <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-background-200 flex items-center justify-center">
              <i className="ri-file-list-3-line text-foreground-400 text-2xl w-8 h-8 flex items-center justify-center" />
            </div>
            <p className="text-foreground-500">该分类下暂无文章</p>
          </div>
        )}
      </div>
    </main>
  );
}